import { ScreeningInsightsResponse } from '@estercare/ester-shared'
import { theme } from '../../theme/theme'
import { ChartStep, SegmentRow } from '../../components/charts/type'

export const SEVERITY_KEYS = {
  mild: 'mild',
  moderate: 'moderate',
  severe: 'severe',
} as const

export type SeverityKey = (typeof SEVERITY_KEYS)[keyof typeof SEVERITY_KEYS]

const CONDITION_STEP_KEY = 'women'

export const getConditionSteps = (t: (key: string) => string): ChartStep[] => [
  {
    key: CONDITION_STEP_KEY,
    name: t('admin.statistics.severityByConditionUnit'),
    color: theme.color.plum,
    ink: theme.color.white,
  },
]

// Our own wording where we have it. Not a whitelist — the API can return any scored condition.
const CONDITION_LABEL_KEYS: Record<string, string> = {
  pmsPmds: 'admin.statistics.conditionPmsPmds',
  menopause: 'admin.statistics.conditionMenopause',
  menstrualPain: 'admin.statistics.conditionMenstrualPain',
  incontinence: 'admin.statistics.conditionIncontinence',
  heavyBleeding: 'admin.statistics.conditionHeavyBleeding',
}

/** One row per condition the API returned, biggest cohort first. */
export const getConditionRows = (
  severityByCondition: ScreeningInsightsResponse['severityByCondition'],
  t: (key: string) => string
): SegmentRow[] => {
  if (!severityByCondition) return []

  return severityByCondition.conditions
    .map(({ key, label, n }) => ({
      key,
      // Untranslated beats missing: dropping a bar would change what the chart claims.
      label: CONDITION_LABEL_KEYS[key] ? t(CONDITION_LABEL_KEYS[key]) : label,
      values: { [CONDITION_STEP_KEY]: n },
    }))
    .sort((a, b) => b.values[CONDITION_STEP_KEY] - a.values[CONDITION_STEP_KEY])
}
